/* eslint-disable */
// @ts-nocheck
import React from "react";
import { ComboBox, FormLabel } from "@carbon/react";
import FieldTooltip from "../tooltip/Tooltip";

interface IProps {
  className?: string;
  label?: string;
  placeholder?: string;
  selectedItem?: any;
  initialSelectedItem?: any;
  items: Array;
  onChange: (value?: any) => void;
  tooltipText?: string;
  required?: boolean;
  disabled?: boolean;
  setSearchTerm?: (value: string) => void;
  warn?: boolean;
  warnText?: string;
}

const DropdownSearchField = ({
  className,
  label,
  placeholder,
  selectedItem,
  initialSelectedItem,
  items,
  onChange,
  tooltipText,
  required,
  disabled = false,
  setSearchTerm,
  warn = false,
  warnText = "",
}: IProps) => {
  const filterItems = (data: { item?: any; inputValue: any }) => {
    const { inputValue } = data;
    if (setSearchTerm) setSearchTerm(inputValue);
    return data?.item?.toLowerCase().includes(data?.inputValue?.toLowerCase());
  };
  return (
    <div className="form-wrapper">
      <div className="form-label">
        <FormLabel data-cy={`${label?.replaceAll(" ", "")}-textlabel`}>
          {label} {required === true ? "*" : null}
        </FormLabel>
        {tooltipText ? (
          <FieldTooltip
            label={tooltipText}
            fieldName={`${label?.replaceAll(" ", "")}-`}
          />
        ) : null}
      </div>
      <ComboBox
        className={className}
        placeholder={placeholder || label}
        selectedItem={selectedItem}
        initialSelectedItem={initialSelectedItem}
        items={items}
        onChange={(e) => {
          onChange(e);
        }}
        shouldFilterItem={filterItems}
        disabled={disabled}
        required={required}
        data-cy={`${label.replaceAll(" ", "")}-comboBox`}
        warn={warn}
        warnText={warnText}
      />
    </div>
  );
};

export default DropdownSearchField;
